<template>
	<div>
		<div id="non-printable">
			<v-toolbar flat fixed>
			    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

			    <v-toolbar-title class="white--text">Stock Journal</v-toolbar-title>

			    <v-spacer></v-spacer>

			    <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

			    <!-- <v-btn icon @click="fn_getBottomMenu(901)">
			      <v-icon>more_vert</v-icon>
			    </v-btn> -->

			    <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
			</v-toolbar>


			<div class="hasToolbar hasExtension grey-back" v-scroll="onScroll">

				<div class="filter-display grey-back" v-if="listItemObject.totalCount">
					<v-layout row wrap>
						<v-flex xs6 sm6 md6>
							<div class="display-block white-background">
								<span font11 light-opacity-color>Count</span><br>
								<span font16 class="filter-display-value">{{$root.numberToLocale(listItemObject.totalCount, 1)}}</span>
							</div>
						</v-flex>
						<v-flex xs6 sm6 md6>
							<div class="display-block white-background">
								<span font11 light-opacity-color>Total Amount</span><br>
								<span font16 class="filter-display-value">&#8377; {{$root.numberToLocale(listItemObject.totalAmount)}}</span>
							</div>
						</v-flex>
					</v-layout>
				</div>


				<v-list grey-back two-line nopadding>

					<!-- <div v-if="listItemObject.totalCount">
						<v-divider></v-divider>
							<v-subheader subheader-dense color-light-grey>{{listItemObject.totalCount}} records</v-subheader>
						<v-divider></v-divider>
					</div> -->

					<div white-background v-for="(item, index) in listItemObject.items" :key="index" :class="{'margin-top-ten':index!=0}">
						<v-list-tile class="right-subtitle-tile" @click="fn_itemClick(item.transactionId)">
						    <v-list-tile-content>
						      <v-list-tile-title class="mb-1">
						      	<!-- {{item.mergeTransactionNumber}} -->
						      	<span class="primary-color">{{item.mergeTransactionNumber}}</span>
						      	&nbsp;| {{item.transactionDate | moment("DD-MMM-YYYY")}}
						      </v-list-tile-title>
						      <v-list-tile-sub-title class="mb-1">
								<span>{{item.transactionDate | moment("DD-MMM-YYYY")}}</span>
						      </v-list-tile-sub-title>
						    </v-list-tile-content>

						    <v-list-tile-action align-flex-end>

						    	<!-- <v-btn icon flat @click="fn_getBottomMenu(902, item.transactionId)" v-if="item.status">
						    		<v-icon>more_horiz</v-icon>
						    	</v-btn> -->
						    	
						    	<div class="warning-label" v-if="!item.status">Cancelled</div>
						    	<div v-else></div>

						    	<div>&#8377; {{$root.numberToLocale(item.amount)}}</div>
						    </v-list-tile-action>
						</v-list-tile>

						<!-- <v-divider v-if="listItemObject.items.length-1 != index"></v-divider> -->
						<v-divider v-if="item.invoiceTemplate"></v-divider>
						<div right-align style="padding:2px 6px" v-if="item.invoiceTemplate">
							<v-btn nomargin icon flat @click="fn_bindInvoiceTemplate('sharewhatsapp', item)"><img src="../../../../assets/icon_whatsapp.svg" style="width:20px" alt="whatapp_icon"></img></v-btn>
							<v-btn nomargin icon flat @click="fn_bindInvoiceTemplate('share', item)"><v-icon font20>share</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="fn_bindInvoiceTemplate('print', item)"><v-icon font20>print</v-icon></v-btn>
					    	<v-btn nomargin icon flat @click="fn_preview(item)">
					    		<img src="../../../../assets/icon_preview_black.svg" style="width:20px" alt="whatapp_icon"></img>
					    	</v-btn>
					    </div>
					</div>

					<!-- <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
						<div slot="no-more"></div>
						<div slot="no-results"></div>
					</infinite-loading> -->
					<!-- <div white-background padding-all-16 center-align v-if="loadMore">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
					</div> -->
			
				</v-list>

				<transition name="fade" mode="out-in">

					<v-card noshadow class="create-placeholder-card" v-if="showPlaceHolder && !listItemObject.totalCount">
						<v-card-text @click="fn_new">

							<div center-align>
				            	<div v-ripple class="placeholder-icon">
				            		<i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
				            		<img src="../../../../assets/icon_wallet.svg" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color">Create New {{toolbarTitle}}</p>
				            </div>
						</v-card-text>
					</v-card>
					
					<!-- <v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 162px);display: flex;align-items: center;">
						<v-card-text>

							<div center-align>
				            	<div @click="fn_new" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
				            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
				            		<img src="../../../../assets/icon_wallet.svg" style="opacity:0.6;width:42px" alt="">
				            	</div><br>

				            	<p class="title light-opacity-color" style="line-height:28px !important">Create New {{toolbarTitle}}</p>
				            </div>

						</v-card-text>
					</v-card> -->
				</transition>

				<!-- <div class="display_msg" v-if="!listItemObject.items.length">There are no items</div> -->
			</div>
		</div>

		<dialog-drive-alert ref="ref_dialogDriveAlert"></dialog-drive-alert>
	</div>
</template>

<script>
var tagId = null;
const menuItem = require('../../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../../config.js').configs.bottomSheetMenu;
const transactionForms = require('../../../../config.js').configs.transactionForms;

import dialogDriveAlert from '../dialogs/dialog_drive_alert'
// import InfiniteLoading from 'vue-infinite-loading';

import {transactionMixin} from '../../transaction_mixin'

	export default{
		props:['settings'],
		mixins: [transactionMixin],
		components: {
		    // InfiniteLoading,
		    'dialog-drive-alert':dialogDriveAlert
		},
		data(){
			return{
				listItemObject:{"items":[], "totalCount":0, "totalAmount":null},
				searchValue:'',
				infiniteId: +new Date(),
				startIndex:0,
				scrollPositionTop:0,
				selectedItemId:null,
				loadMore:false,
				showPlaceHolder:false
			}
		},
		methods:{

			fn_preview: function(item){
		        item.toolbarTitle = "Stock Journal";
		        let printType = 'sj';
		        this.fn_previewInvoice(true, null, printType, item);
		    },

		    fn_bindInvoiceTemplate: function(type, item){

		        this.printTemplate = null;
		        this.printData = null;

		        this.printTemplate = require('../../../invoice_templates/invoices/template'+item.invoiceTemplate).default;
		        console.log(this.printTemplate);

		        let dataFnName = 'StockJournalPrintData';

		        if(type=='sharewhatsapp'){
		          this.fn_shareInvoice('sharewhatsapp', item, dataFnName);
		        }
		        else if(type=='print'){
		          this.fn_getPrintData(dataFnName, item.transactionId, 'print', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }
		        else if(type=='pdf'){
		          this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', null, item.mergeTransactionNumber, item.transactionDate, item.transactionListId);
		        }
		        else if(type=='share'){
		          this.fn_shareInvoice('share', item, dataFnName);
		        }
		    },

		    fn_shareInvoice: function(type, item, dataFnName){
		        let shareObj = {};
		        shareObj.shareType = type=='sharewhatsapp' ? 'share' : 'ShareOther';
		        shareObj.type = 'pdf';
		        // shareObj.primaryMobileNumber = item.primaryMobileNumber && type == 'sharewhatsapp' ? item.primaryMobileNumber : null;
		        shareObj.subject = "Stock Journal";
		        // shareObj.email = item.email ? [item.email] : null ;
		        // shareObj.textMessage = "Dear "+item.accountLedgerName+",\n\nBelow are your invoice details. Please find the attached pdf of your invoice.\n\nInvoice Date: "+this.$moment(item.createdDate).format('DD-MMM-YYYY')+"\nTotal Amount: ₹ "+this.$root.fixed2Decimal(item.roundedAmount)+"\n\nThank You,\n"+this.$root.CurrentBusiness.BusinessName;
		        this.fn_getPrintData(dataFnName, item.transactionId, 'pdf', shareObj, item.mergeTransactionNumber, null, item.transactionListId);
		    },

			onScroll (event) {
		        var element = event.target;
			    if (element.documentElement.scrollHeight - element.documentElement.scrollTop - 150 <= element.documentElement.clientHeight)
			    {
			        console.log('scrolled');
			        if(this.listItemObject.items.length < this.listItemObject.totalCount){
			        	this.fn_loadItems();
			        }
			    }
		    },

			fn_drafts: function(){
				this.$router.push({path:'/drafts', query:{tabIndex:1}});
			},
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='new'){
					// this.fn_new();
				}
				else if(menuAction=='edit'){
					this.$router.push({path:'/transactions/inventory/stockjournal/items/'+this.selectedItemId+'/edit'});
				}
				else if(menuAction=='copy'){
					// this.$router.push({path:"/transactions/"+this.toolbarTitle.toLowerCase().replace(/ /g,'')+"/items/new", query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
				}
				else if(menuAction=='draft'){
					// this.$router.push({path:'/drafts', query:{category:this.toolbarTitle}});
				}
			},

			// fn_checkDrive: function(){
		 //        let self = this;
		 //        if(this.$root.CurrentBusiness.DataDrive){
		 //          this.fn_new();
		 //        }
		 //        else{
		 //          this.$root.fn_getTransactionCount(function(count){
		 //            if(count>=10){
		 //              self.$refs['ref_dialogDriveAlert'].dialog_setup_drive = true;
		 //            }
		 //            else{
		 //              self.fn_new();
		 //            }
		 //          })
		 //        }
		 //    },

			fn_new: function () {
				localStorage.setItem("SetDataDrive", 1);
				this.$router.push({path:'/transactions/inventory/stockjournal/items/new', query:{tagId:this.guidWeb()}});
			},

			fn_itemClick: function (itemId) {
				// tagId id form future use
				// itemName id form future use
				this.$router.push({path:'/transactions/inventory/stockjournal/items/'+itemId});
			},

			fn_getBottomMenu: function (elementId, itemId) {
				itemId ? this.selectedItemId = itemId : '';

				let bottomMenu;

				// if(elementId == bottomSheetMenu.toolBar.Id){
				// 	bottomMenu = {"BottomMenu": [menuItem.help]};
				// }
				if(elementId == bottomSheetMenu.masterListItems.Id){
					bottomMenu = {"BottomMenu": [menuItem.edit]};
				}
				
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			// infiniteHandler($state) {
		 //    	let filterObject = {};
			// 	filterObject.type = this.settings.transactionTypeId;
			// 	filterObject.limit = 10;
			// 	filterObject.startIndex = this.startIndex;
			// 	filterObject.search = this.searchValue.toLowerCase();

			// 	let self = this;
			// 	this.getItems("AccountBookList", filterObject, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 				let responseJson = JSON.parse(response);
			// 				self.listItemObject.totalCount = responseJson.totalCount;

			// 				for(let i in responseJson.items){
			// 					self.listItemObject.items.push(responseJson.items[i]);	
			// 				}

			// 				self.startIndex = self.listItemObject.items.length;

			// 				if(self.listItemObject.items.length < self.listItemObject.totalCount){
			// 					// self.listItemObject.items = self.listItemObject.items.concat(responseJson.items);
			// 					// self.startIndex = self.listItemObject.items.length;
			// 					$state.loaded();
			// 				}
			// 				else {
   //        						$state.complete();
   //      					}
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
		 //    },

			// fn_searchItem: function () {
			// 	this.startIndex = 0;
			// 	this.infiniteId += 1;
			// 	this.listItemObject.items = [];
			// },

			fn_loadItems: function(search) {
		    	let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';

				let self = this;
				this.getItems("AccountBookList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;
							self.listItemObject.totalAmount = responseJson.totalAmount;

							search ? self.listItemObject.items = [] : '';
							for(let i in responseJson.items){
								self.listItemObject.items.push(responseJson.items[i]);	
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },

			fn_searchItem: function () {
				this.startIndex = 0;
				this.listItemObject.items = [];
				this.fn_loadItems(true);
			},

			fn_showWebView: function () {
				let viewObject = {};
				let self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},
		},
		mounted: function(){
			tagId = this.$route.query.tagId;

			this.fn_showWebView();
			window.js_globals.fn_onBackPress = this.fn_goBack;

			let self = this;
			document.addEventListener('scroll', function () {
				self.scrollPositionTop = window.pageYOffset
			});

			this.fn_loadItems();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_journal/items.vue